import { Card, CardBody, Col } from "reactstrap";
import { H4, Image, LI, P, UL } from "../../../../../AbstractElements";
import { Comment } from "../../../../../Constants/Constants";
import { CommentBoxData, SingleBlogContentTop } from "../../../../../Data/Miscellaneous/Learning";
import { dynamicImage } from "../../../../../Utils";
import CommentSection from "./CommentSection";

const BlogDetails = () => {
  return (
    <Col xl="9" className="xl-60 order-xl-0 order-1 box-col-12">
      <Card>
        <CardBody>
          <div className="blog-single">
            <div className="blog-box blog-details">
              <Image className="img-fluid w-100" src={dynamicImage(`faq/learning-1.png`)} alt="blog-main" />
              <div className="blog-details pb-0">
                <UL className="simple-list flex-row blog-social">
                  <LI>{"25 July 2024"}</LI>
                  <LI><i className="icofont icofont-user"></i>{"Mark "}<span>{"Jecno"}</span></LI>
                  <LI><i className="icofont icofont-thumbs-up"></i>{"02 "}<span>{"Hits"}</span></LI>
                  <LI><i className="icofont icofont-ui-chat"></i>{"598 Comments"}</LI>
                </UL>
                <H4 className="pt-2">{"Knowledge can be defined as awareness of facts or as practical skills. there is wide agreement among philosophers that it is a form of true belief.Internet."}</H4>
                <div className="single-blog-content-top">
                  {SingleBlogContentTop.map((item, index) => (<P key={index}>{item}</P>))}
                </div>
              </div>
            </div>
            <section className="comment-box">
              <H4>{Comment}</H4>
              <hr />
              <UL className="simple-list">
                {CommentBoxData.map((item) => (
                  <LI key={item.id}>
                    {item.id !== 2 ? (
                      <CommentSection item={item} colClass="col-md-4 xl-100" socialComment={true} />
                    ) : (
                      <UL>
                        <LI><CommentSection item={item} colClass="col-xl-12" /></LI>
                      </UL>
                    )}
                  </LI>
                ))}
              </UL>
            </section>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BlogDetails;
